import React, { useEffect, useState } from "react";
import { RefreshSavedCollections } from "@/components/CollectionsPage/redux/actions";
import { BookmarkCollectionItemApi } from "@/components/common/api";
import { setIsOpenOnboardingSteps } from "@/components/ProfileSideDrawer/redux/slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import AuthTokenSelector from "@/redux/slice/auth/selectors/authToken";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import UserOnboardedSelector from "@/redux/slice/auth/selectors/userOnboarded";
import { handleOpenLoginModal } from "@/redux/slice/auth/slice";
import CollectionsSelector from "@/components/CollectionsPage/redux/selectors/collectionsSelector";
import styles from "./BookmarkAction.module.scss";

interface BookmarkActionProps {
  type: string;
  itemId: number;
}

const Bookmark: React.FC<BookmarkActionProps> = (props) => {
  const { type: ItemType, itemId } = props;
  const dispatch = useAppDispatch();
  const authToken = useAppSelector(AuthTokenSelector);
  const signedInStatus = useAppSelector(signedInStateSelector);
  const isOnboarded = useAppSelector(UserOnboardedSelector);
  const collectionsData = useAppSelector(CollectionsSelector);
  const [isItemBookmarked, setIsItemBookmarked] = useState<boolean>(false);

  const checkIsBookmarked = () => {
    if (collectionsData) {
      const allSaved = collectionsData?.all;
      const isExist = allSaved?.data?.some((item: any) => {
        return item?.id === itemId && item?.type === ItemType;
      });
      setIsItemBookmarked(isExist);
    }
  };

  const handleBookmarkClickApi = async () => {
    try {
      const bookmarkResponse: any = await BookmarkCollectionItemApi({
        authToken: authToken,
        type: ItemType,
        action: isItemBookmarked ? "remove" : "add",
        itemId,
      });

      if (bookmarkResponse?.savedContent) {
        await dispatch(RefreshSavedCollections(authToken));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (isOnboarded && signedInStatus === SignedinState.SIGNEDIN) {
      handleBookmarkClickApi();
    } else {
      if (signedInStatus !== SignedinState.SIGNEDIN) {
        dispatch(handleOpenLoginModal(true));
      } else {
        if (signedInStatus === SignedinState.SIGNEDIN && !isOnboarded) {
          dispatch(setIsOpenOnboardingSteps(true));
        }
      }
    }
  };

  useEffect(() => {
    checkIsBookmarked();
  }, [collectionsData]);

  return (
    <div className={styles.container} onClick={handleOnClick}>
      <span className={`icon-bookmark-fill ${styles.icon} ${isItemBookmarked ? "" : styles.noActive}`} />
    </div>
  );
};

export default Bookmark;
